/**
 * Task W: Full-plan-only modules (customer subscriptions, staff attendance / clock-in) — upgrade notes, "Full" badges,
 * Platform admin overrides. One row per key: [key, English, 中文]. Malay falls back to English.
 */
const ROWS = [
  ["tw.full.badge","Full","全功能"],
  ["tw.up.badgeTitle","Available on the Full plan","全功能方案提供"],
  ["tw.feat.attendance","Staff attendance & clock-in","员工考勤与打卡"],
  ["tw.feat.subscriptions","Customer subscriptions","顾客订阅"],
  ["tw.up.title","{feature} — available on the Full plan","{feature}——全功能方案提供"],
  ["tw.up.attendance","Staff clock in and out with their PIN on the front-desk tablet or their own login. You see hours, breaks and corrections per branch, and staff see their own attendance.","员工可在前台平板用 PIN 或用自己的账号上下班打卡。你可按分店查看工时、休息与更正记录，员工也能查看自己的考勤。"],
  ["tw.up.subscriptions","Sell monthly service plans, packages and memberships that Stripe charges automatically every month — each payment adds the customer's sessions and is recorded as a sale.","销售按月服务方案、配套与会员，由 Stripe 每月自动扣款——每笔扣款自动加次数并记为销售。"],
  ["tw.up.att1","Staff clock in on their own phone, with a GPS check at the shop","员工用自己的手机打卡，GPS 确认人在店里"],
  ["tw.up.att2","Attendance report per branch and CSV export","按分店的考勤报表，可导出 CSV"],
  ["tw.up.att3","Staff see their own hours in the staff portal","员工可在个人门户查看自己的工时"],
  ["tw.up.sub1","Customers scan a QR code and add their card once","顾客扫码绑卡，只需一次"],
  ["tw.up.sub2","Automatic monthly billing through your own Stripe account","通过你自己的 Stripe 账户每月自动扣款"],
  ["tw.up.sub3","MRR, renewals, churn and failed payments at a glance","月度经常性收入、续费、流失与扣款失败一目了然"],
  ["tw.up.cta","Upgrade to Full","升级到全功能"],
  ["tw.up.compare","Compare plans","比较方案"],
  ["tw.up.askOwner","Ask the shop owner to upgrade to the Full plan.","请店主升级到全功能方案。"],
  ["tw.up.native","Available on the Full plan. The owner can upgrade in the owner portal on the web (Settings → Plan & billing).","全功能方案提供。店主可在网页版店主后台升级（设置 → 方案与账单）。"],
  ["tw.pa.overrides","Feature overrides","功能例外设置"],
  ["tw.pa.grandfathered","kept (grandfathered)","保留（旧用户权益）"],
  ["tw.pa.on","on","开启"],
  ["tw.pa.off","off","关闭"],
] as const;

export type TwKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<TwKey, string>;

export const taskW = { en: col(1), zh: col(2), ms: col(1) };
